var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _path25, _rect, _rect2, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2e11b88-9979-41d9-b96e-aeb07020f934",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 766.79921,
    height: 566.46484,
    viewBox: "0 0 766.79921 566.46484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407.76069,528.30664a13.88061,13.88061,0,0,1-1.44727-27.68262l114.98121-12.27734a6.50743,6.50743,0,0,1,7.15307,5.77295l1.56714,14.67627a6.49967,6.49967,0,0,1-5.77319,7.15332L409.26093,528.22656A14.09589,14.09589,0,0,1,407.76069,528.30664Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.96235,540.91748a22.00107,22.00107,0,0,1-2.877-43.811l39.65283-5.25879,5.78467,43.61816-39.65283,5.25879A22.13927,22.13927,0,0,1,405.96235,540.91748Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M983.39961,376.89258h-372v-210.125h372Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M983.39961,376.89258h-372v-210.125h372Zm-370-2h368v-206.125h-368Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M780.0334,338.33008h-119a3.00328,3.00328,0,0,1-3-3v-70a3.00328,3.00328,0,0,1,3-3h119a3.00328,3.00328,0,0,1,3,3v70A3.00328,3.00328,0,0,1,780.0334,338.33008Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M938.20674,209.33008H656.59248a2,2,0,0,1,0-4H938.20674a2,2,0,0,1,0,4Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M938.20674,240.33008H656.59248a2,2,0,0,1,0-4H938.20674a2,2,0,0,1,0,4Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M938.20674,271.33008H803.0334a2,2,0,0,1,0-4H938.20674a2,2,0,0,1,0,4Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M938.20674,302.33008H803.0334a2,2,0,0,1,0-4H938.20674a2,2,0,0,1,0,4Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M938.20674,333.33008H803.0334a2,2,0,0,1,0-4H938.20674a2,2,0,0,1,0,4Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M740.29341,298.34026a6.61925,6.61925,0,0,0-9.51026-.17l-33.48974,33.49a4.72889,4.72889,0,0,1-6.66993.01l-4.96-4.95a6.60323,6.60323,0,0,0-9.34033,0l-9.59961,9.61H774.34321v-1.37Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M780.0334,338.33008h-119a3.00328,3.00328,0,0,1-3-3v-70a3.00328,3.00328,0,0,1,3-3h119a3.00328,3.00328,0,0,1,3,3v70A3.00328,3.00328,0,0,1,780.0334,338.33008Zm-119-74a1.00114,1.00114,0,0,0-1,1v70a1.00114,1.00114,0,0,0,1,1h119a1.00115,1.00115,0,0,0,1-1v-70a1.00115,1.00115,0,0,0-1-1Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M797.39961,443.23242a26,26,0,1,1,26-26A26.02947,26.02947,0,0,1,797.39961,443.23242Zm0-50a24,24,0,1,0,24,24A24.02734,24.02734,0,0,0,797.39961,393.23242Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M810.39961,418.23242h-26a1,1,0,0,1,0-2h26a1,1,0,0,1,0,2Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M797.39961,431.23242a1,1,0,0,1-1-1v-26a1,1,0,1,1,2,0v26A1.00005,1.00005,0,0,1,797.39961,431.23242Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M892.39961,443.23242a26,26,0,1,1,26-26A26.02947,26.02947,0,0,1,892.39961,443.23242Zm0-50a24,24,0,1,0,24,24A24.02734,24.02734,0,0,0,892.39961,393.23242Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M901.592,427.4248a.99634.99634,0,0,1-.707-.293l-18.38477-18.38477a.99989.99989,0,1,1,1.41406-1.41406L902.299,425.71777a1,1,0,0,1-.707,1.707Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M883.20722,427.4248a1,1,0,0,1-.707-1.707L900.885,407.333a.99989.99989,0,1,1,1.41406,1.41406l-18.38477,18.38477A.99633.99633,0,0,1,883.20722,427.4248Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M702.39961,443.23242a26,26,0,1,1,26-26A26.02947,26.02947,0,0,1,702.39961,443.23242Zm0-50a24,24,0,1,0,24,24A24.02734,24.02734,0,0,0,702.39961,393.23242Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M691.16956,425.98616a.8317.8317,0,0,1-.41661-1.55195l12.47407-7.20182L690.753,410.03056a.83174.83174,0,0,1,.8316-1.44069L705.306,416.512a.83187.83187,0,0,1,0,1.44069l-13.72148,7.92217A.82805.82805,0,0,1,691.16956,425.98616Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M709.568,428.87489a.83165.83165,0,0,1-.8316-.83161V406.42156a.8316.8316,0,0,1,1.66321,0v21.62172A.83166.83166,0,0,1,709.568,428.87489Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M383.32746,732.2417H368.56794a6.50745,6.50745,0,0,1-6.5-6.5V602.72754a6.50744,6.50744,0,0,1,6.5-6.5h14.75952a6.50744,6.50744,0,0,1,6.5,6.5V725.7417A6.50745,6.50745,0,0,1,383.32746,732.2417Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M420.51972,732.2417H405.7602a6.50737,6.50737,0,0,1-6.5-6.5V602.72754a6.50736,6.50736,0,0,1,6.5-6.5h14.75952a6.50736,6.50736,0,0,1,6.5,6.5V725.7417A6.50737,6.50737,0,0,1,420.51972,732.2417Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M447.39961,591.23242c0-2.81-.12012-5.72-.33985-8.69-.09033-1.2-.20019-2.42-.32031-3.64-3.80762-37.02069-23.5293-82.904-47.33984-93.43817v-6.23181a2.00006,2.00006,0,0,0-2-2h-18a2.00006,2.00006,0,0,0-2,2v7.31165c-22.061,12.26941-38.20655,56.34881-41.41016,92.19836-.11963,1.26-.21973,2.51-.29,3.74q-.29956,4.5-.2998,8.75c0,25.43549,8.04589,37.56311,21,43.23493v15.76507a2.00005,2.00005,0,0,0,2,2h33a2.00006,2.00006,0,0,0,2-2v-11.035c.66845-.01074,1.33642-.02173,2-.03888v11.07391a2.00005,2.00005,0,0,0,2,2h33a2.00006,2.00006,0,0,0,2-2v-20.501C441.635,622.83521,447.39961,611.0968,447.39961,591.23242Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.38436,
    cy: 250.0813,
    r: 51,
    fill: "#ff9100"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M404.02229,433.25781c3.30591-.09179,7.42029-.20654,10.59-2.522a8.13272,8.13272,0,0,0,3.20008-6.07275,5.47082,5.47082,0,0,0-1.86036-4.49315c-1.65551-1.39894-4.073-1.72707-6.67822-.96144l2.69922-19.72559-1.98144-.27148-3.17322,23.18994,1.65466-.75928c1.91834-.87988,4.55164-1.32764,6.188.05518a3.51513,3.51513,0,0,1,1.15271,2.8955,6.14689,6.14689,0,0,1-2.38123,4.52784c-2.46667,1.80175-5.74621,2.03418-9.46582,2.13818Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205.17177,
    y: 234.4165,
    width: 10.77161,
    height: 2,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171.17177,
    y: 234.4165,
    width: 10.77161,
    height: 2,
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M390.41665,365.698a45.161,45.161,0,0,0-15.65745-31.62241,44.09921,44.09921,0,0,0-64.73321,8.96458,44.97075,44.97075,0,0,0-6.45379,34.86215c1.64135,6.96389,4.88282,13.43522,8.283,19.68374,3.3911,6.23183,6.86542,12.3928,9.72977,18.89307a150.42347,150.42347,0,0,1,12.65266,63.28074,112.13014,112.13014,0,0,1-1.85656,19.60205c-2.20723,11.18458-7.03034,22.90166-17.32647,28.89127-6.00379,3.49261-13.04761,4.58517-19.89171,4.88588a92.27149,92.27149,0,0,1-21.55423-1.31892c-12.58986-2.44269-24.83462-9.04266-30.69993-20.93815a27.22189,27.22189,0,0,1-2.58448-8.39332,1.552,1.552,0,0,0-1.5-1.5,1.50721,1.50721,0,0,0-1.5,1.5c1.64917,12.41022,10.70974,22.52907,21.77813,27.79218a62.72784,62.72784,0,0,0,20.22389,5.40282,94.288,94.288,0,0,0,21.44952.00673c6.58774-.80115,13.14069-2.65083,18.5349-6.65428a36.75432,36.75432,0,0,0,10.83821-13.287c5.56816-11.19428,6.90217-24.0965,7.0964-36.43393a153.449,153.449,0,0,0-12.53736-63.12687c-2.8375-6.59833-6.283-12.85632-9.73238-19.14679-3.40927-6.2173-6.70562-12.58469-8.40815-19.51168a40.37114,40.37114,0,0,1-.17769-18.3362,41.16542,41.16542,0,0,1,21.26363-27.97341,40.89021,40.89021,0,0,1,58.33553,25.788,39.56851,39.56851,0,0,1,1.42777,8.68979c.09845,1.92105,3.099,1.93276,3,0Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M380.33622,365.95369a26.10359,26.10359,0,0,0-26.94474-21.91083c-1.92139.0961-1.93289,3.09668,0,3a23.1691,23.1691,0,0,1,16.195,5.37551,23.48685,23.48685,0,0,1,7.85693,14.33284c.29035,1.90239,3.18157,1.09424,2.89284-.79752Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M375.98475,357.84888h15a5,5,0,0,1,5,5v0a5,5,0,0,1-5,5h-15a5,5,0,0,1-5-5v0A5,5,0,0,1,375.98475,357.84888Z",
    transform: "translate(-311.02894 -28.2371) rotate(-18.27222)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M381.98847,641.68555H367.229a6.50745,6.50745,0,0,1-6.5-6.5V519.55127a13.87976,13.87976,0,1,1,27.75952,0V635.18555A6.50745,6.50745,0,0,1,381.98847,641.68555Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#ff9100"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M598.60039,733.23242h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M398.89961,566.73242h-44v-40a22,22,0,0,1,44,0Z",
    transform: "translate(-216.60039 -166.76758)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.44678ebef5834331daae3b7908d7fc25.svg";
export { ForwardRef as ReactComponent };